import { default as mr } from '@repo/common-utils/utils/systemTip'
import { getAppLocale, toLegacyLangType } from '@repo/common-utils/utils/appLocale'

// 开户相关页面路径
const OPEN_ACCOUNT_PATHS = [
  '/openAccount',
  '/openEsopAccount',
  '/openAccountTZYM',
  '/openAccountXJB',
  '/openAccountDCB',
  '/openAccountXCBPro',
  '/startAccount',
  '/startAccountTZYM',
]

// 开户相关 API 接口
const OPEN_ACCOUNT_APIS = [
  '/kyc/',
  '/client/',
  '/account/',
  '/cms/v1/MRConfig',
  '/cms/v1/AccountOpeningAreaType',
  '/cms/v1/ApplyDetail',
  '/cms/v1/ApplyCheck',
  '/cms/v1/ApplyStart',
  '/cms/v1/GetUserDetail',
  '/cms/v1/GetEsopUserDetail',
  '/cms/v1/WebIPLocationGet',
  '/cms/v1/PostionInfo',
]

// 检查当前是否在开户相关页面
const isOpenAccountPage = () => {
  const currentPath = window.location.pathname
  return OPEN_ACCOUNT_PATHS.some((path) => currentPath.includes(path))
}

// 检查是否是开户相关 API
const isOpenAccountAPI = (url) => {
  return OPEN_ACCOUNT_APIS.some((api) => url.includes(api))
}

export default (response) => {
  // 检查当前页面和 API 是否属于开户流程
  const isOpenAccountFlow = isOpenAccountPage() || isOpenAccountAPI(response?.config?.url || '')

  if (response?.data?.error?.code === 100029) {
    // 如果是开户流程，跳过 MR 逻辑
    if (isOpenAccountFlow) {
      console.log('MR interceptor: Skipping MR logic for open account flow')
      return response
    }

    // MR
    const { data } = response.data.error
    console.log(data)
    const padStartZero = (num) => num.toString().padStart(2, '0')
    const startTimeDate = new Date(data.startTime * 1000 /* 需转换成毫秒 */),
      endTimeDate = new Date(data.endTime * 1000 /* 需转换成毫秒 */)
    const isSameDay = () =>
      startTimeDate.getFullYear() === endTimeDate.getFullYear() &&
      startTimeDate.getMonth() === endTimeDate.getMonth() &&
      startTimeDate.getDate() === endTimeDate.getDate()
    const time = isSameDay()
      ? `${startTimeDate.getFullYear()}年${padStartZero(startTimeDate.getMonth() + 1)}月${padStartZero(
          startTimeDate.getDate()
        )}日${padStartZero(startTimeDate.getHours())}:${padStartZero(startTimeDate.getMinutes())}至${padStartZero(
          endTimeDate.getHours()
        )}:${padStartZero(endTimeDate.getMinutes())}`
      : `${startTimeDate.getFullYear()}年${padStartZero(startTimeDate.getMonth() + 1)}月${padStartZero(
          startTimeDate.getDate()
        )}日${padStartZero(startTimeDate.getHours())}:${padStartZero(startTimeDate.getMinutes())}至${endTimeDate.getFullYear()}年${padStartZero(
          endTimeDate.getMonth() + 1
        )}月${padStartZero(endTimeDate.getDate())}日${padStartZero(endTimeDate.getHours())}:${padStartZero(endTimeDate.getMinutes())}`
    const legacyLang = toLegacyLangType(getAppLocale())
    mr('body', legacyLang === 'zhCn' ? 'zhCn' : 'zhTc', { time })
    return Promise.reject(response)
  }
  return response
}
